// import React, { useRef, useState } from "react";
// import Button from "../../Buttons/Button";
// import Modal from "../../Modal/Modal";
// const sizeClasses = {
//   xs: "p-1",
//   sm: "p-1",
//   md: "p-1.5",
//   lg: "p-2",
//   xl: "p-2",
// };

// const fontSizeClasses = {
//   xs: "text-[12px]",
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const CustomFileInput = ({
//   size = "md",
//   className = "",
//   onChange,
//   accept,
//   multiple = false,
//   placeholder = "Choose file",
//   disabled = false,
// }) => {
//   const [fileName, setFileName] = useState("");
//   const [filesCount, setFilesCount] = useState(0);
//   const [isFocused, setIsFocused] = useState(false);
//   const [isOpenModal, setIsOpenModal] = useState(false);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const fileInputRef = useRef(null);

//   const handleFileChange = (e) => {
//     const files = e.target.files;
//     if (files && files.length > 0) {
//       // If multiple is false, only take the latest file
//       const newFiles = multiple ? Array.from(files) : [files[0]];
//       // If multiple is false, replace existing files instead of adding
//       const updatedFiles = multiple ? [...selectedFiles, ...newFiles] : newFiles;

//       const names = updatedFiles.map((file) => file.name).join(", ");
//       setFileName(names);
//       setFilesCount(updatedFiles.length);
//       setSelectedFiles(updatedFiles);

//       if (onChange && fileInputRef.current) {
//         const dataTransfer = new DataTransfer();
//         updatedFiles.forEach((file) => dataTransfer.items.add(file));
//         fileInputRef.current.files = dataTransfer.files;
//         onChange({ target: { files: dataTransfer.files } });
//       }
//     }
//   };

//   const handleClick = () => {
//     if (!disabled && fileInputRef.current) {
//       fileInputRef.current.click();
//     }
//   };
//   const handleFocus = () => setIsFocused(true);
//   const handleBlur = () => setIsFocused(false);

//   return (
//     <div
//       className={`flex items-center rounded border border-gray-300 hover:border-primary focus:border-primary focus:outline-none ${
//         isFocused ? "border-primary outline-none" : ""
//       }`}
//     >
//       <div
//         className={`flex-1 relative flex items-center overflow-hidden   ${
//           sizeClasses[size]
//         } ${fontSizeClasses[size]} ${className} ${
//           disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
//         }`}
//         onClick={handleClick}
//         onFocus={handleFocus}
//         onBlur={handleBlur}
//         tabIndex="0"
//       >
//         <input
//           type="file"
//           ref={fileInputRef}
//           className="hidden"
//           onChange={handleFileChange}
//           accept={accept}
//           multiple={multiple}
//           disabled={disabled}
//           onFocus={handleFocus}
//           onBlur={handleBlur}
//         />
//         <div className="flex items-center justify-between gap-3 w-full">
//           <div className="flex-1">
//             <button
//               className={`${fontSizeClasses[size]} text-nowrap leading-4 py-1 px-4 bg-neutrals-50 border-[1px]`}
//             >
//               {placeholder}
//             </button>
//           </div>

//           <div className="overflow-hidden gap-3 flex items-center justify-start">
//             <span className={`truncate ${fileName ? "" : "text-gray-500"}`}>
//               {fileName || "No file Chosen"}
//             </span>
//             {filesCount > 1 && (
//               <div className="text-gray-500 flex-1 text-nowrap">
//                 {filesCount} {filesCount > 1 ? "files" : "file"}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       {filesCount > 0 && (
//         <div className="px-2">
//           <Button
//             type="icon"
//             icon={"close"}
//             size="xs"
//             color="dark"
//             variant="text"
//             onClick={() => {
//               setFileName("");
//               setFilesCount(0);
//               setSelectedFiles([]);
//             }}
//           />
//           {multiple && (
//             <Button
//               type="icon"
//               icon={"list"}
//               size="xs"
//               color="dark"
//               variant="text"
//               onClick={() => setIsOpenModal(true)}
//             />
//           )}
//         </div>
//       )}

//       <Modal
//         isOpen={isOpenModal}
//         onClose={() => setIsOpenModal(false)}
//         title="Selected Files"
//         width="max-w-2xl"
//       >
//         <div className="p-1">
//           <div className="flex justify-end mb-2">
//             <Button
//               title="Add More Files"
//               icon="add"
//               size="sm"
//               onClick={() => fileInputRef.current?.click()}
//             />
//           </div>
//           {selectedFiles.map((file, index) => (
//             <div
//               key={index}
//               className="flex items-center justify-between py-2 border-b border-gray-200 last:border-b-0"
//             >
//               <div className="flex items-center gap-4">
//                 <span className="material-icons text-gray-500">
//                   description
//                 </span>
//                 <div>
//                   <p className="font-medium">{file.name}</p>
//                   <p className="text-sm text-gray-500">
//                     {(file.size / 1024).toFixed(2)} KB
//                   </p>
//                 </div>
//               </div>
//               <div className="flex items-center gap-4">
//                 <div className="text-sm text-gray-500">
//                   {file.type || "Unknown type"}
//                 </div>
//                 <Button
//                   type="icon"
//                   icon="delete"
//                   size="xs"
//                   color="danger"
//                   variant="text"
//                   onClick={() => {
//                     const newFiles = selectedFiles.filter(
//                       (_, i) => i !== index
//                     );
//                     setSelectedFiles(newFiles);
//                     setFilesCount(newFiles.length);
//                     setFileName(newFiles.map((f) => f.name).join(", "));
//                     if (onChange && fileInputRef.current) {
//                       const dataTransfer = new DataTransfer();
//                       newFiles.forEach((file) => dataTransfer.items.add(file));
//                       fileInputRef.current.files = dataTransfer.files;
//                       onChange({ target: { files: dataTransfer.files } });
//                     }
//                   }}
//                 />
//               </div>
//             </div>
//           ))}
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default CustomFileInput;

import React, { useRef, useState, useEffect } from "react";
import Button from "../../Buttons/Button";
import Modal from "../../Modal/Modal";

const sizeClasses = {
  xs: "p-1",
  sm: "p-1",
  md: "p-1.5",
  lg: "p-2",
  xl: "p-2",
};

const fontSizeClasses = {
  xs: "text-[12px]",
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const CustomFileInput = ({
  size = "md",
  className = "",
  onChange,
  accept,
  multiple = false,
  placeholder = "Choose file",
  disabled = false,
  shadow = false,
  value,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const fileInputRef = useRef(null);

  // const handleFileChange = (e) => {
  //   const files = e.target.files;
  //   if (files && files.length > 0) {
  //     const newFiles = multiple
  //       ? [...selectedFiles, ...Array.from(files)]
  //       : Array.from(files);
  //     setSelectedFiles(newFiles);
  //     triggerChange(newFiles);
  //   }
  // };

  useEffect(() => {
    // If parent resets the attachments to null or empty array
    if (!value || value.length === 0) {
      setSelectedFiles([]);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  }, [value]);

  const areFilesEqual = (file1, file2) => {
    return (
      file1.name === file2.name &&
      file1.size === file2.size &&
      file1.type === file2.type &&
      file1.lastModified === file2.lastModified
    );
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files?.length > 0) {
      const newFiles = Array.from(files);
      let updatedFiles;

      if (multiple) {
        const uniqueNewFiles = newFiles.filter(
          (newFile) =>
            !selectedFiles.some((existingFile) =>
              areFilesEqual(existingFile, newFile)
            )
        );
        updatedFiles = [...selectedFiles, ...uniqueNewFiles];
      } else {
        updatedFiles = newFiles;
      }

      setSelectedFiles(updatedFiles);
      triggerChange(updatedFiles);
    }
    e.target.value = "";
  };

  const triggerChange = (files) => {
    const dataTransfer = new DataTransfer();
    files.forEach((file) => dataTransfer.items.add(file));
    if (fileInputRef.current) {
      fileInputRef.current.files = dataTransfer.files;
    }
    onChange && onChange(files);
  };

  const handleDeleteFile = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
    triggerChange(newFiles);
  };

  const handleClearAll = () => {
    setSelectedFiles([]);
    triggerChange([]);
  };

  const handleClick = () => {
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  // console.log("selectedFiles..:", selectedFiles);

  return (
    <div
      className={`w-full overflow-hidden flex items-center rounded border focus:outline-none ${
        isFocused ? !disabled && "border-primary outline-none" : ""
      } 
      ${shadow ? "border-gray-50 inputShadow" : "border-gray-300"}
      ${
        disabled
          ? "border-neutrals-200 bg-neutrals-200 cursor-not-allowed"
          : "hover:border-primary focus:border-primary"
      }`}
    >
      <div
        className={`flex-1 relative flex items-center overflow-hidden ${
          sizeClasses[size]
        } ${fontSizeClasses[size]} ${className} ${
          disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }`}
        onClick={handleClick}
        onFocus={handleFocus}
        onBlur={handleBlur}
        tabIndex="0"
      >
        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          onChange={handleFileChange}
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        <div className="flex items-center justify-between gap-3 w-full overflow-hidden ">
          <div className="flex-1">
            <button
              className={`${fontSizeClasses[size]} text-nowrap leading-4 py-1 px-4 bg-neutrals-50 border-[1px]`}
            >
              {placeholder}
            </button>
          </div>

          <div className="overflow-hidden gap-3 flex items-center justify-start">
            <span
              className={`truncate ${
                selectedFiles.length ? "" : "text-gray-500"
              }`}
            >
              {selectedFiles.length
                ? selectedFiles.map((f) => f.name).join(", ")
                : "No file Chosen"}
            </span>
            {selectedFiles.length > 1 && (
              <div className="text-gray-500 flex-1 text-nowrap">
                {selectedFiles.length}{" "}
                {selectedFiles.length > 1 ? "files" : "file"}
              </div>
            )}
          </div>
        </div>
      </div>
      {selectedFiles.length > 0 && (
        <div className="px-2">
          <Button
            type="icon"
            icon={"close"}
            size="xs"
            color="dark"
            variant="text"
            onClick={handleClearAll}
          />
          {multiple && (
            <Button
              type="icon"
              icon={"list"}
              size="xs"
              color="dark"
              variant="text"
              onClick={() => setIsOpenModal(true)}
            />
          )}
        </div>
      )}

      <Modal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        title="Selected Files"
        width="max-w-2xl"
      >
        <div className="p-1">
          <div className="flex justify-end mb-2">
            <Button
              title="Add More Files"
              icon="add"
              size="sm"
              onClick={() => fileInputRef.current?.click()}
            />
          </div>
          {selectedFiles.length > 0 ? (
            selectedFiles.map((file, index) => (
              <div
                key={index}
                className="flex items-center justify-between py-2 border-b border-gray-200 last:border-b-0"
              >
                <div className="flex items-center gap-4">
                  <span className="material-icons text-gray-500">
                    description
                  </span>
                  <div>
                    <p className="font-medium">{file.name}</p>
                    <p className="text-sm text-gray-500">
                      {(file.size / 1024).toFixed(2)} KB
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-sm text-gray-500">
                    {file.type || "Unknown type"}
                  </div>
                  <Button
                    type="icon"
                    icon="delete"
                    size="xs"
                    color="danger"
                    variant="text"
                    onClick={() => handleDeleteFile(index)}
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4 text-gray-500">
              No files selected
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default CustomFileInput;
